import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Col, Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faUndo, faFileExcel
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";
// let columns = [
//   {
//     name: "S.No",
//     selector: "srNo",
//     sortable: false,
//     grow: 1,
//   },

//   {
//     name: "City",
//     selector: "city",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Asset Name",
//     selector: "assetName",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Brand Name",
//     selector: "brandName",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Lease Status",
//     selector: "leaseStatus",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Lease Number",
//     selector: "leaseCode",
//     sortable: false,
//     grow: 3,
//   },  
//   {
//     name: "Gross Leasable Area",
//     selector: "gross_leasable_area",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Lease Expiry Date",
//     selector: "led",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Renewal Option",
//     selector: "renewal_option",
//     sortable: false,
//     grow: 3,
//   },
//   {
//     name: "Renewal Notice",
//     selector: "renewal_notice",
//     sortable: false,
//     grow: 3,
//   }  
// ];

//let columns = columns;

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear, prm, fetchUrl, DownloadFile }) => (
  <>
    {/* <a href={fetchUrl +prm+'&export=true'}> */}
    <button type="button" onClick={DownloadFile} className="download_button">
      Download
    </button>
    {/* </a> */}
  </>
);



const LeaseDocumentTable = ({ asset, brand, formConfig, expiry_report, columns, expiry_lockin_report, fetchUrl }) => {

  if (typeof formConfig == "undefined") {
    formConfig = {
      'page': 0, 'per_page': 10
    };
  }

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);


  React.useEffect(() => {
    fetchLeaseData(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };


    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
        prm={prm}
        fetchUrl={fetchUrl}
        DownloadFile={DownloadFile}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchLeaseData = async (page) => {


    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;

    if (typeof expiry_report != "undefined" && expiry_report == "true") {
      //formConfig['export'] = 'true';
    }

    if (typeof expiry_lockin_report != "undefined" && expiry_lockin_report == "true") {
      //formConfig['expiry_lockin_report'] = 'true';
    }

    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");


    setLoading(true);
    //asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    const response = await axios.get(
      `${fetchUrl}` + prm
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchLeaseData(page);
  };


  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;
    if (typeof expiry_report != "undefined") {
      formConfig['expiry_report'] = 'true';
    }
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");

    const response = await axios.get(
      `${fetchUrl}` + prm
    );
    //`${apiUrl.apiUrl.url}/lease-report/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1`
    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchLeaseData(1);
  }, []);


  function DownloadFile() {
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    var self = this;
    axios({
      method: "post",
      url: fetchUrl + prm + '&export=true&sendLink=true',
    }).then(function (response) {
      window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
    });

  }

  // subHeaderComponent={subHeaderComponentMemo}
  return (
    <>
      <div className="tableContainer">
        <DataTable
          
          columns={columns}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>
    </>
  );
};
export default LeaseDocumentTable;
